import React from 'react';

export type ConfirmChoiceVariant = 'safe' | 'destructive';

type Props = {
  name: string;
  value: string;
  checked: boolean;
  onSelect: () => void;
  variant: ConfirmChoiceVariant;
  title: React.ReactNode;
  description?: React.ReactNode;
  disabled?: boolean;
  /** Tighter padding for destructive confirm dialogs. */
  compact?: boolean;
};

/** Compact selectable row for destructive confirm modals — entire row is clickable. */
export default function ConfirmChoiceCard({
  name,
  value,
  checked,
  onSelect,
  variant,
  title,
  description,
  disabled = false,
  compact = true,
}: Props) {
  const classes = [
    'confirm-option',
    'confirm-choice-card',
    `confirm-choice-card--${variant}`,
    compact ? 'confirm-choice-card--compact' : '',
    checked ? 'confirm-choice-card--selected' : '',
    disabled ? 'confirm-choice-card--disabled' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <label className={classes}>
      <input
        type="radio"
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={() => {
          if (!disabled) onSelect();
        }}
        className="confirm-choice-card__input"
      />
      <span className="confirm-choice-card__body">
        <span className="confirm-choice-card__title">{title}</span>
        {description ? (
          <span className="confirm-choice-card__description muted">{description}</span>
        ) : null}
      </span>
    </label>
  );
}
